export class AssetUpsertModel {
  ApiId: number;
  CustomerNumber: string;
  SiteNumber: string;
  Make: string;
  Model: string;
  SerialNumber: string;
  AssetTag: string;
  ManufacturedYear: any;
  InstallDate: any;
  CustomerAssetNumber: string;
  Issues: string;
  Column: string[];
}
